import styled from "styled-components";
import { Colors } from "../../config/Constants";
import Button from "../Button";
import ListWithPagination from "../ListsWithPagination";
import { TableWithPagination } from "../TableWithPagination";

type ReportMerchantTableProps = {
  data: {
    id: number;
    customer: string;
    customerId: string;
    transactionDateandTime: string;
    transactionAmount: string;
  }[];
  currentPage: number;
  totalData: number;
  rowsPerPage: number;
  // onEdit: (id: string) => void;
  isTableDataLoading: boolean;
  onPageChange: (page: number) => void;
  onDispute: (data: any) => void;
};

const ReportMerchantTable = ({
  data,
  isTableDataLoading,
  totalData,
  currentPage,
  rowsPerPage,
  onPageChange,
  onDispute,
}: ReportMerchantTableProps) => {
  const columns = [
    {
      path: "id",
      label: "SI",
    },
    {
      path: "customerId",
      label: "Customer ID",
    },
    {
      path: "transactionDateandTime",
      label: "Transaction Date & Time",
    },
    {
      path: "amount_qar",
      label: "QAR",
    },
    {
      path: "amount_points",
      label: "Points",
    },
    {
      path: "transactionAmount",
      label: "Transaction Amount",
    },
    {
      path: "action",
      label: "Action",
      content: (data: any) => (
        <Button
          variant="filled"
          label="Dispute"
          onClick={() => onDispute(data)}
          color={Colors.red}
          disabled={data.disableRefundBtn}
        />
      ),
    },
  ];
  return (
    <>
      <TableWrapper>
        <TableWithPagination
          onPageChange={onPageChange}
          totalData={totalData}
          currentPage={currentPage}
          rowsPerPage={rowsPerPage}
          columns={columns}
          data={data}
          isTableDataLoading={isTableDataLoading}
        />
      </TableWrapper>
      <ListWrapper>
        <ListWithPagination
          onPageChange={onPageChange}
          totalData={totalData}
          currentPage={currentPage}
          rowsPerPage={rowsPerPage}
          columns={columns}
          data={data}
          isTableDataLoading={isTableDataLoading}
          title={"Report Details"}
        />
      </ListWrapper>
    </>
  );
};
const ListWrapper = styled.div`
  display: none;
  @media only screen and (max-width: 768px) {
    display: block;
  }
`;

const TableWrapper = styled.div`
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;
export default ReportMerchantTable;
